export function formatDurationHms(value, unit = "hours") {
    if (value == null || value === "" || isNaN(Number(value))) return "00:00:00";

    const totalSeconds = Math.max(
        0,
        Math.round(unit === "seconds" ? Number(value) : Number(value) * 3600)
    );
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds].map((n) => String(n).padStart(2, "0")).join(":");
}

export function handleFormatQuantityConsumedToNumber(value) {
    if (!value) return 0;

    const newVal = String(value);

    const replacedValue = newVal.replace(/[^\d]/g, "");

    const onlyDigits = replacedValue
        .split("")
        .filter((s) => /\d/.test(s))
        .join("")
        .padStart(5, "0");

    if (isNaN(onlyDigits)) {
        return;
    }

    const digitsFloat = onlyDigits.slice(0, -4) + "." + onlyDigits.slice(-4);

    return Number(digitsFloat);
}

export function handleFormatQuantityConsumedToString(value) {
    let raw = String(value ?? "").trim().replace(/\./g, ",");

    if (raw === "") return "0";

    raw = raw.replace(/[^\d,]/g, "");

    const commaIndex = raw.indexOf(",");
    let integerPart = "";
    let decimalPart = "";

    if (commaIndex === -1) {
        integerPart = raw;
    } else {
        integerPart = raw.slice(0, commaIndex);
        decimalPart = raw.slice(commaIndex + 1).replace(/,/g, "");
    }

    integerPart = integerPart.replace(/\D/g, "").slice(0, 9);
    decimalPart = decimalPart.replace(/\D/g, "").slice(0, 9);

    if (integerPart === "") {
        integerPart = "0";
    } else if (integerPart.length > 1) {
        integerPart = integerPart.replace(/^0+/, "") || "0";
    }

    if (commaIndex === -1) {
        return integerPart;
    }

    return `${integerPart},${decimalPart}`;
}

export function formatCurrencyWithoutSymbol(value, formatInputModal = false) {
    if (value === null || value === undefined) return "";

    const numberValue =
        typeof value === "string"
            ? formatInputModal
                ? handleFormatQuantityConsumedToString(value)
                : handleFormatQuantityConsumedToNumber(value)
            : value;

    let formattedValue = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
    }).format(numberValue);

    return formattedValue;
}

export function handleConsumedRequired(quantityRequired, quantityConsumed, required) {
    if (quantityRequired !== null && !quantityConsumed && !required) {
        return quantityRequired;
    }

    return quantityConsumed;
}

export function getOperationStatusName(orderItem) {
    return String(
        orderItem?.operation?.statusName ||
        orderItem?.operation?.status?.name ||
        orderItem?.operation?.currentStatus ||
        orderItem?.status?.name ||
        ""
    ).trim();
}

export function isNotStartedOperationStatus(status) {
    return !status || status === "Não Iniciado" || status === "Not Started";
}

export function isFinishedOperationStatus(status) {
    return status === "Operação Finalizada" || status === "Completed";
}

export function isAppointmentableMultipleOrder(orderItem) {
    const status = getOperationStatusName(orderItem);

    return !isNotStartedOperationStatus(status) && !isFinishedOperationStatus(status);
}

export function filterAppointmentableMultipleOrders(orders) {
    return (orders || []).filter(isAppointmentableMultipleOrder);
}
